module.exports = __webpack_public_path__ + "img/head-bg.7ac266a.webp";